import React from 'react';
import { Box, keyframes, styled } from '@mui/material';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-6px);
  }
`;

export const TypingDots: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <BouncingDot sx={{ animationDelay: '-0.4s' }} />
      <BouncingDot sx={{ animationDelay: '-0.2s' }} />
      <BouncingDot />
    </Box>
  );
};

const BouncingDot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: (theme.vars || theme).palette.text.disabled,
  animation: `${bounce} 1.5s infinite ease-in-out`,
}));
